import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAssaVwMzfK8UK76Ml331Bb7vhgoJPLU4Y",
  authDomain: "pelagic-bonbon-406608.firebaseapp.com",
  projectId: "pelagic-bonbon-406608",
  storageBucket: "pelagic-bonbon-406608.firebasestorage.app",
  messagingSenderId: "90481637872",
  appId: "1:90481637872:web:89955555463857f3150535",
  measurementId: "G-MT1S1XW6MF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();